import type { EventDetailSectionId } from '../types/event-detail'

export const EVENT_DETAIL_TAB_IDS = ['about', 'tickets', 'speakers', 'attendees', 'exhibitors'] as const

const isEventDetailTabId = (value: string): value is EventDetailSectionId => {
  return (EVENT_DETAIL_TAB_IDS as readonly string[]).includes(value)
}

export const firstRouteValue = (raw: unknown): string => {
  if (typeof raw === 'string') return raw.trim()
  if (Array.isArray(raw)) return String(raw[0] ?? '').trim()
  return ''
}

export const toEventDetailTabId = (value: string): EventDetailSectionId | undefined => {
  const normalized = value.startsWith('#') ? value.slice(1) : value
  if (!normalized || !isEventDetailTabId(normalized)) return undefined
  return normalized
}
